<form [formGroup]="mainForm">
<!--  <h1>{{ organizationDetails.OrganizationName }}</h1>-->
  <div class="p-grid p-fluid no-margin">
      @if(!hasExistingPaymentMethod) {
          <div class="col-md-12 col-sm-12 col-xs-12">
              <div [ngClass]="{'jp-card-visa' : ccType === 'Visa', 'jp-card-mastercard' : ccType === 'Mastercard',
      'jp-card-discover' : ccType === 'Discover', 'jp-card-ames' : ccType === 'amex', 'jp-card-flipped' : flipped}" class="jp-card">
                  <div class="jp-card-front">
                      @switch (ccType) {
                          @case ('Visa') {
                              <div class="jp-card-logo jp-card-visa">Visa</div>
                          }
                          @case ('Mastercard') {
                              <div class="jp-card-logo jp-card-mastercard">Mastercard</div>
                          }
                          @case ('Discover') {
                              <div class="jp-card-logo jp-card-discover">discover</div>
                          }
                          @case ('amex') {
                              <div class="jp-card-logo jp-card-amex"></div>
                          }
                      }

                      <div class="jp-card-lower">
                          <div class="jp-card-shiny"></div>
                          <div class="jp-card-cvc jp-card-display jp-card-invalid">•••</div>
                          <div class="jp-card-number jp-card-display jp-card-invalid">

                              @if (mainForm.get('cc').value) {
                                  {{ mainForm.get('cc').value | creditCard }}
                              } @else {
                                  •••• •••• •••• ••••
                              }
                          </div>
                          <div class="jp-card-name jp-card-display jp-card-invalid">
                              @if (mainForm.get('fullName').value) {
                                  {{ mainForm.get('fullName').value }}
                              } @else {
                                  John Smith
                              }

                          </div>
                          <div class="jp-card-expiry jp-card-display jp-card-invalid" data-after="valid
thru" data-before="MM/YY">
                              @if (mainForm.get('expMonth').value) {
                                  {{ mainForm.get('expMonth').value }}
                              } @else {
                                  ••
                              } /
                              @if (mainForm.get('expYear').value) {
                                  {{ mainForm.get('expYear').value }}
                              } @else {
                                  ••
                              }


                          </div>
                      </div>
                  </div>
                  <div class="jp-card-back">
                      <div class="jp-card-bar"></div>
                      <div class="jp-card-cvc jp-card-display jp-card-invalid">
                          @if (mainForm.get('verificationNumber').value) {
                              {{ mainForm.get('verificationNumber').value }}
                          } @else {
                              •••
                          }
                      </div>
                      <div class="jp-card-shiny"></div>
                  </div>
              </div>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
              <label class="registration-label">Name as it appears on card<sup class="req">*</sup></label>
              <input formControlName="fullName" pInputText type="text"/>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
              <label class="registration-label">Credit/Debit Card<sup class="req">*</sup></label>
              <input (keydown)="removeSpaces($event)" formControlName="cc" maxlength="16" pInputText type="text"/>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
              <label class="registration-label">Exp. Month (2 digits)<sup class="req">*</sup></label>
              <input (keydown)="numberOnly($event)" col-xs-12 formControlName="expMonth" maxlength="2" pInputText type="text"/>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
              <label class="registration-label">Exp. Year (2 digits)<sup class="req">*</sup></label>
              <input (keydown)="numberOnly($event)" formControlName="expYear" maxlength="2" pInputText type="text"/>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
              <label class="registration-label">Verification #<sup class="req">*</sup></label>
              <input (blur)="flipped = false" (focus)="flipped = true" (keydown)="numberOnly($event)" formControlName="verificationNumber" maxlength="4" pInputText
                     type="text"/>
          </div>
          <div class="col-md-12 col-sm-12 margin-top-10 checkbox">
              <p-checkbox
                      formControlName="useMailing"
                      binary="true"
                      [value]="true"/>
              <label>Use Mailing Address for Billing Address</label>
          </div>
          @if(personPrefill && contextService.contextObject.tenantName && mainForm.get('useMailing').value === false) {
              <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10 registration-address">
                  <app-address-form-custom  [canTabWrite]="true" [showCounty]="false" [showZipPlus4]="false" [incomingAddressBilling]="incomingAddressBilling"
                                            [showCategory]="false" (outgoingAddress)="setAddress($event)" [disabled]="mainForm.get('useMailing').value === true"></app-address-form-custom>
              </div>
          }
      } @else {
          <div class="col-md-12 col-sm-12 col-xs-12 existing-payment">
            <p>
              There is already an existing Payment Method attached to this account. If you would like to proceed using it,
              continue by hitting next. If you would like to create a new one, you may do so by clicking "New Payment Method".
              <br />
              <br />
              Current Payment Method - {{personPrefill.PaymentMethod.CCCardType }} ending in {{cardEnding}}
            </p>
          </div>
<!--          <div class="col-md-12 col-sm-12 col-xs-12 new-payment-button">-->
<!--              <p-button (click)="hasExistingPaymentMethod = false"  label="Create New Payment Method"/>-->
<!--          </div>-->

      }

    <div class="contribution">
      @for (rate of registrationPrefillRates; track rate; let i = $index; ) {
        @if(!rate.Recurring) {
          <div class="rate-item">{{rate.Description}} (One Time Payment) = ${{rate.Amount}}</div>
        } @else {
          <div class="rate-item">{{rate.Description}} (Monthly Recurring Payment) = ${{rate.Amount}}</div>
        }
      }
      <span class="pay-today">Pay Today = ${{totalAmount}}</span>
    </div>
    @if(!hasExistingPaymentMethod) {
      <div class="next-page-button">
        <p-button (click)="goToNextPage()" [disabled]="mainForm.invalid" label="Next"/>
      </div>
    } @else {
      <div class="col-md-6 col-sm-6 col-xs-12 next-page-button split-button margin-top-5">
        <p-button (click)="createNewPaymentMethod()"  label="New Payment Method"/>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12 next-page-button split-button margin-top-5">

          <p-button (click)="goToNextPage()" [disabled]="mainForm.invalid" label="Next"/>

      </div>
    }
  </div>
</form>
